var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ active: _vm.alertCount != 0 },attrs:{"id":"notification-tab"},on:{"click":_vm.notifications}},[_c('v-avatar',[(true)?_c('v-icon',{attrs:{"dark":""}},[_vm._v(" mdi-bell ")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }